import { User } from '@wavingroup/iot-core/gen/ts/wavin/ignite/v1/user_pb';
import { igniteUserPromiseClient } from '~/services/ignite-client';

export const LIST_USERS_BY_NAMES_BATCH_SIZE = 1000;

export const listUsersByNames = async (names: string[]): Promise<User[]> => {
  const uniqueNames = [...new Set(names)];
  if (uniqueNames.length === 0) {
    return [];
  }

  const response = await igniteUserPromiseClient.listUsersByNames({
    names: uniqueNames.slice(0, LIST_USERS_BY_NAMES_BATCH_SIZE),
  });
  const remainingUsers = await listUsersByNames(
    uniqueNames.slice(LIST_USERS_BY_NAMES_BATCH_SIZE),
  );

  return [...response.users, ...remainingUsers];
};
